module.exports = __webpack_public_path__ + "static/mailchimp-bc260ae9c7737c46b74bd4fbfb191ad7.svg";